import type { BigNumberish } from 'ethers';
import React from 'react';

import { CountDown } from '../../common/countdown/CountDown.component';
import { Button, Colors } from '../../legacy/button/Button.component';
import { AuctionCard } from './AuctionCard.component';
import styles from './NFTCard.module.css';
import { WalletBalanceCard } from './WalletBalanceCard.component';

export interface NFTCardProps {
  auctionId: BigNumberish;
  isLoggedIn: boolean;
  image: string;
  seller: string;
  title: string;
  description: string;
  currentBid: string;
  walletBalance: string;
  onPressPlaceBid: (auctionId: BigNumberish) => void;
  onClickGetMoreStars: () => void;
  isLive: boolean;
  endDate: Date;
  hasEnded: boolean;
  winner?: string;
}

export const NFTCard: React.FC<NFTCardProps> = props => {
  const { onClickGetMoreStars } = props;

  return (
    <AuctionCard>
      <div className={styles.nftCardContainer}>
        <div className={styles.imageContainer}>
          <video
            className={styles.image}
            src={props.image}
            autoPlay
            loop
            muted
          />
        </div>
        <div className={styles.nftDetails}>
          <div className={styles.spacingContainer}>
            <div className={styles.profileContainer}>
              <div className={styles.profileName}>{props.seller}</div>
            </div>
            <div className={styles.title}>{props.title}</div>
            <p className={styles.description}>{props.description}</p>
          </div>
          <div className={styles.spacingContainer}>
            <p className={styles.bidTitle}>
              {props.hasEnded
                ? 'sold for'
                : props.isLive
                ? 'current bid'
                : 'starting price'}
            </p>
            <div className={styles.bidContainer}>
              <div className={styles.bidAmount}>
                {parseFloat(props.currentBid).toLocaleString('en-us', {
                  maximumFractionDigits: 2,
                  useGrouping: true,
                })}
              </div>
              <div className={styles.bidUnit}> stars</div>
            </div>
          </div>
          {props.isLive && (
            <div className={styles.spacingContainer}>
              <div className={styles.bidTitle}>auction ends in</div>

              <CountDown date={props.endDate} numberSize="48px" />
            </div>
          )}
          {props.hasEnded && (
            <div className={styles.spacingContainer}>
              <div className={styles.bidTitle}>owned by</div>
              <div className={styles.winnerContainer}>
                <div className={styles.winnerName}>{props.winner}</div>
              </div>
            </div>
          )}
          {(props.isLive || props.hasEnded) && (
            <div className={styles.spacingContainer}>
              <WalletBalanceCard getMoreStars={onClickGetMoreStars} />
            </div>
          )}
          <Button
            color={Colors.COLOR_SCHEME_2}
            className={styles.placeBidButton}
            onClick={() => props.onPressPlaceBid(props.auctionId)}
            disabled={!props.isLive && !props.hasEnded}
          >
            Place Bid
          </Button>
        </div>
      </div>
    </AuctionCard>
  );
};
